import { render, staticRenderFns } from "./WidgetIntegration.vue?vue&type=template&id=f82cb9fc&scoped=true"
import script from "./WidgetIntegration.vue?vue&type=script&lang=js"
export * from "./WidgetIntegration.vue?vue&type=script&lang=js"
import style0 from "./WidgetIntegration.vue?vue&type=style&index=0&id=f82cb9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82cb9fc",
  null
  
)

export default component.exports